import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import LineEditForm from '../../elements/lines/form';
import Loading from './../../elements/loading';
import LinesAdd from './../../elements/lines/widget/lines_add';

class LineEdit extends Component {
	render() {
		const { lines, strategies} = this.props;
		return (
			lines.isFetching || strategies.isFetching ? <Loading/>:<LineEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.strategiesList();
		this.props.fetchLineComplete(this.props.match.params.id);
	}
}

export default BaseLayout(LineEdit, {
	title:"Editar linea",
	subnav: {
		icon: 'fa-flag-checkered',
		name: 'Proigualdad',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <LinesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/lines/edit.jsx